import { inject, Injectable } from "@angular/core";
import { MouvementStoreService } from "./mouvement-store.service";
import { LotMouvement } from "../../models/lot.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { MouvementApiService } from "./mouvement-api.service";
import {
  Untrack,
  UpdateStatus,
} from "../../../../shared/store/utils/store-utils.service";
import { firstValueFrom } from "rxjs";
import { PaginatedResponse } from "../../models/mouvements.model";
import { TypeMouvement } from "../../enums/type-mouvement.enum";
import { ArticlesInfosFacadeService } from "../../../articles/services/article-infos/article-infos-facade.service";
import { SearchUtils } from "../../../../shared/utils/search.utils";
import { PaginatedEntityFacadeService } from "../../../../shared/store/pagination/paginated-entity-facade.service";

@Injectable({ providedIn: "root" })
export class MouvementFacadeService extends PaginatedEntityFacadeService<
  LotMouvement,
  MouvementApiService,
  EntityMetadata,
  MouvementStoreService
> {
  articleInfosFacade = inject(ArticlesInfosFacadeService);

  constructor() {
    const api = inject(MouvementApiService);
    const store = inject(MouvementStoreService);
    super(api, store);
    this.store.initStatus(MouvementFacadeService);
  }

  @Untrack
  @UpdateStatus
  async loadAllFilter(filters: {
    pageSize?: number;
    page?: number;
    limit?: number;
    articleIds?: string[];
    search?: string;
    type: TypeMouvement[];
    dates: { start: Date; end: Date };
  }): Promise<LotMouvement[]> {
    if (filters.search) {
      const allAis = this.articleInfosFacade.getAllEntities()();
      filters.articleIds = allAis
        .filter(
          (ai) =>
            SearchUtils.isIncluded(filters.search, ai.denomination) ||
            SearchUtils.isIncluded(filters.search, ai.code),
        )
        .map((ai) => ai.articleId);
    }

    const response = (await firstValueFrom(
      this.api.loadAllFilter(filters),
    )) as PaginatedResponse<LotMouvement>;

    // Remplacer les entités (pas addMany pour éviter d'accumuler)
    this.store.addMany(response.data);

    return response.data;
  }

  @Untrack
  @UpdateStatus
  async loadByLotId(lotId: string) {
    const mouvements = await firstValueFrom(this.api.loadByLotId(lotId));
    this.store.addMany(mouvements);
    return mouvements;
  }

  @Untrack
  @UpdateStatus
  async loadByOfId(ofId: string) {
    const mouvements = await firstValueFrom(this.api.loadByOfId(ofId));
    this.store.addMany(mouvements);
    return mouvements;
  }
}
